import { useEffect, useState } from "react";

export function SvgRenderer({
  src,
  className,
}: {
  src: string;
  className?: string;
}) {
  const [svg, setSvg] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchSvg = async () => {
      try {
        setError(null);
        setSvg(null);

        const res = await fetch(
          `/api/svg-proxy?url=${encodeURIComponent(src)}`
        );

        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Failed to fetch SVG: ${res.status}`);
        }

        const svgText = await res.text();

        if (!cancelled) {
          setSvg(svgText);
        }
      } catch (err: any) {
        if (!cancelled) {
          console.error("SVG fetch error:", err);
          setError(err.message || "Unknown error");
          setSvg(null);
        }
      }
    };

    fetchSvg();

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (error) return null;
  if (!svg) return null;

  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: svg }} />
  );
}
